import classnames from 'classnames';

import PopperTooltip from 'shared/ui/Popper/PopperTooltip';

import { Button } from '../Button';
import { buttonSize } from '../ButtonTypes';

import styles from './BlockButtons.module.scss';

type TopSubmitBlockType = {
  onCancelForm: () => void;
  submitText: string;
  cancelText: string;
  isDisabledSubmit?: boolean;
  isDisabledCancel?: boolean;
};

export const TopSubmitBlock: React.FC<TopSubmitBlockType> = ({
  onCancelForm,
  submitText,
  cancelText,
  isDisabledSubmit = false,
  isDisabledCancel = false,
}) => (
  <div key="top-submit-block" className="pull-right">
    <PopperTooltip placement="bottom" overlay={submitText}>
      <Button
        type="submit"
        className={classnames(styles.position, 'btn-box-tool text-success')}
        disabled={isDisabledSubmit}
        size={buttonSize.small}
      >
        {<i className="lnr lnr-checkmark-circle" />}
      </Button>
    </PopperTooltip>
    <PopperTooltip placement="bottom" overlay={cancelText}>
      <Button
        type="button"
        className={classnames(styles.position, 'btn-box-tool margin-left')}
        disabled={isDisabledCancel}
        onClick={onCancelForm}
        size={buttonSize.small}
      >
        {<i className="lnr lnr-cross-circle" />}
      </Button>
    </PopperTooltip>
  </div>
);
